<template>
	<FieldWrapper v-bind="wrapper">
		<div class="dropdown">
			<select ref="field" :id="name" :name="name" v-model="model" :disabled="disabled">
				<option v-if="placeholder" value="" disabled>{{ placeholder }}</option>
				<option v-for="o in options" :key="o.value" :value="o.value" :disabled="o.disabled">{{
					o.label
				}}</option>
			</select>
		</div>
	</FieldWrapper>
</template>

<script>
import FieldWrapper from '@/components/FieldWrapper'
import field from '@/mixins/field'

export default {
	name: 'FieldSelect',
	props: {
		optionLabel: String,
		options: Array,
	},
	mixins: [field],
	components: {
		FieldWrapper,
	},
}
</script>

<style lang="scss" scoped>
@import '~scss/components';
.dropdown {
	position: relative;
	background-color: $col-field;

	&::after {
		content: '';
		position: absolute;
		width: 0.5rem;
		height: 0.5rem;
		border: 2px solid $black;
		border-top: 0;
		border-left: 0;
		top: 50%;
		right: 0.75rem;
		transform: translateY(-75%) rotate(45deg);
	}
}
select {
	@extend %field;
	padding-right: 2rem;
}
</style>
